<template>
  <router-link :to="'/user/' + user.slug" class="link-profile">
    <div class="image-circle">
      <img v-if="user.profileimg === 'default'" src="https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f" class="image-circle">
      <img v-else :src="user.profileimg" class="image-circle">
    </div>
    <div class="info">
      <h5>{{ user.firstname + ' ' + user.surname }}</h5>
      <!-- <span class="reputation">{{ rep['.value'] }}</span> -->
      <span class="job">{{ user.jobtitle }}</br>{{ user.organisation }}</span>
    </div>
  </router-link>
</template>

<script>
import { db } from '@/firebase'

export default {
  name: 'SingleMember',
  props: ['member'],
  firebase () {
    return {
      user: {
        source: db.ref('users/' + this.member),
        asObject: true
      },
      rep: {
        source: db.ref('user-meta/reputation/' + this.member),
        asObject: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SingleMember.vue?c47d4778